import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-change"
export default class extends Controller {
  static targets = ["master", "slave"]

  connect() {
    console.log("select-change controller connected")
  }

  change() {
    const value = this.masterTarget.value
    const template = document.querySelector(`template[data-subject-type="${value}"]`)
    this.slaveTarget.innerHTML = template.innerHTML
  }
}
